import styled from 'styled-components';

import Input from 'components/ui/Input';
import FormRow from 'components/FormRow';
import Modal, { ModalHeader, ModalForm } from 'components/Modal';
import useDeleteProject from './hooks/useDeleteProject';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.span`
  margin-bottom: 20px;
  font-weight: 500;
`;

const DeleteText = styled.span`
  margin-bottom: 10px;
  b {
    font-weight: 500;
  }
`;

interface ProjectDeleteModalProps {
  ownerName: string;
  projectName: string;
}

const ProjectDeleteModal = ({ ownerName, projectName }: ProjectDeleteModalProps) => {
  const {
    isLoading,
    formState: { errors },
    register,
    handleSubmit,
    onValid,
  } = useDeleteProject({ ownerName, projectName });

  return (
    <Modal maxWidth={480}>
      <ModalHeader>프로젝트 삭제</ModalHeader>
      <ModalForm isLoading={isLoading} buttonText="프로젝트 삭제하기" onSubmit={handleSubmit(onValid)}>
        <Container>
          <Title>정말 삭제하시겠어요?</Title>
          <span>삭제된 모든 내용은 되돌릴 수 없어요</span>
          <DeleteText>
            삭제를 원하시면 하단에{' '}
            <b>
              {ownerName}/{projectName}
            </b>
            를 입력해주세요
          </DeleteText>
          <FormRow error={errors?.text?.message}>
            <Input {...register('text')} />
          </FormRow>
        </Container>
      </ModalForm>
    </Modal>
  );
};

export default ProjectDeleteModal;
